import { LanguageType } from 'types';

export const EVENT_TYPE_DICTIONARY = {
	[LanguageType.English]: {
		CREATE_RECORD: 'Created record',
		DELETE_CODELIST: 'Deleted codelist',
		DELETE_RECORDS: 'Deleted record',
		EXPORT_RECORDS: 'Exported records',
		GET_RECORD: 'Viewed record',
		IMPORT_BULK_RECORDS: 'Imported codelist',
		PARTIAL_IMPORT_RECORDS: 'Imported codelist',
		SEARCH_RECORDS: 'Searched records',
		UPDATE_RECORD: 'Updated record',
		GET_RECORD_HISTORY: 'Viewed codelist history',
		GET_RECORD_ACCESS_HISTORY: 'Viewed record access history',
		EXPORT_HISTORY_LOG: 'Exported history log'
	},

	[LanguageType.Norwegian]: {
		CREATE_RECORD: 'Opprettet kodeliste',
		DELETE_CODELIST: 'Slettet kodeliste',
		DELETE_RECORDS: 'Slettet rad',
		EXPORT_RECORDS: 'Eksporterte kodeliste',
		GET_RECORD: 'Så på kodelisterad',
		IMPORT_BULK_RECORDS: 'Importerte kodeliste',
		PARTIAL_IMPORT_RECORDS: 'Importerte kodeliste',
		SEARCH_RECORDS: 'Søkte i kodeliste',
		UPDATE_RECORD: 'Oppdaterte rad',
		GET_RECORD_HISTORY: 'Så på kodelistehistorikk',
		GET_RECORD_ACCESS_HISTORY: 'Så på tilgangshistorikk',
		EXPORT_HISTORY_LOG: 'Eksporterte historikklogg'
	}
};
